import { Component, OnInit, Input } from '@angular/core';
import { generateColumns } from '../../../../../common/functions/column-functions';
import { ApiService } from '../../../../../common/services/api.service';
import { URL } from '../../../environments/environment';

interface IColumnProduct {
    text?: Array<string>;
    code?: number;
    region?: string;
    tax?: string;
    prefixText: string;
    value?: string;
    buttonDebit?: { href: string, id: string };
    buttonTransfer?: { href: string, id: string };
}

interface IResultTableColumns {
    columns: Array<IColumnProduct>;
}

export interface IResultTable {
    header: Array<string>;
    body: Array<IResultTableColumns>;
}

@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {
    @Input() data;
    public linkType: string;
    public showAlertMessage: boolean = false;
    public isLinkifyAvailable: boolean = false;
    public isLinkifyLoading: boolean = true;
    public transferUnavailableTooltip: string = 'Transferencia temporalmente no disponible, vuelva a intentar más tarde o escoja otro método de pago';

    public dataResult: IResultTable = {
        header: [
            'Descripción del producto',
            'N° Orden',
            'Total a Pagar',
            'Método de pago'
        ],
        body: []
    }

    private checkLinkifyAvailability(): void {
        this.apiService.isLinkifyWorking(URL.LINKIFY_VALIDATE_ACCOUNT).subscribe({
            next: (result) => {
                this.isLinkifyAvailable = result;
                this.isLinkifyLoading = false;
            },
            error: () => {
                this.isLinkifyLoading = false;
            }
        });
    }

    constructor(private readonly apiService: ApiService) { }

    ngOnInit(): void {
        if (this.data.show) {
            if (this.data.status === 'found') {
                this.checkLinkifyAvailability();
                [this.data, this.linkType, this.dataResult] = generateColumns(this.data, this.linkType, this.dataResult);
            }
            if (this.data.status === 'Found finished') {
                this.showAlertMessage = true;
            }
        }
    }


    public navigateTo(url: string): void {
        window.open(url, '_blank');
    }
}
